import type { ParameterValue } from "@/components/workflows/utils/helpers/parameterTypes";
import type { ParseRowsNodeData } from "../csv/types";

/** Omega's `ExcelCellValues` wire values; left out on save means `text`. */
export const CELL_VALUES_OPTIONS = ["text", "typed"] as const;
export type CellValues = (typeof CELL_VALUES_OPTIONS)[number];

/**
 * Parse CSV's data plus the Excel-only parameters. The settings panel edits
 * `sheet`, `startRow`, and `cellValues`.
 */
export type ParseExcelNodeData = ParseRowsNodeData & {
  sheet?: ParameterValue<string>;
  startRow?: ParameterValue<number>;
  cellValues?: ParameterValue<CellValues>;
};
